import * as React from 'react';

import { View, WBCheckbox } from '@/core';
import styles from './style';
import { ID, ItemType, ValueType } from './model';

interface Props {
	items: ItemType[];
	internalValue: ValueType;
	onCheckboxChange: (id: ID, checked: boolean) => void;
}

const SelectMultiple: React.FC<Props> = ({ items, internalValue, onCheckboxChange }) => {
	return (
		<View style={styles.select}>
			{items.map((item) => (
				<View key={item.id} style={styles.row}>
					<WBCheckbox
						checked={internalValue.includes(item.id)}
						onChange={(checked) => onCheckboxChange(item.id, checked)}
						label={item.label}
					/>
				</View>
			))}
		</View>
	);
};

export default SelectMultiple;
